import Fetch from '../../../mixins/Fetch'

const loadTipoAvisoList = async ({ commit }) => {
  const request = await Fetch.get('contentManagement/getTipoAvisoProgramado')

  commit(
    'SETTIPOAVISOPROGRAMADOLIST',
    request.map((a) => ({ value: a.id, text: a.descricao }))
  )
}

const setDateSelected = ({ commit }, date) => {
  commit('SETDATESELECTED', date)
}

const setEventSelected = ({ commit }, event) => {
  commit('SETEVENTSELECTED', event)
}

const saveAvisoProgramado = async ({ commit }, data) => {
  const request = await Fetch.post(
    'contentManagement/addAvisoProgramado',
    data
  )

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const loadListAvisos = async ({ commit }, status) => {
  const request = await Fetch.get(
    'contentManagement/listAvisoProgramado',
    status
  )

  if (request.status === 'error') throw new Error(request.message)

  const result = Array.isArray(request) ? request : []

  switch (status) {
    case 'programados':
      commit('SETLISTAVISOSPROGRAMADOS', result)
      break
    case 'ativos':
      commit('SETLISTAVISOSATIVOS', result)
      break
    default:
      commit('SETLISTAVISOSEXPIRADOS7DIAS', result)
      break
  }
}

const loadEventPublicoAlvo = async ({ commit }, idEvent) => {
  const request = await Fetch.get('contentManagement/getPublicoAlvo', idEvent)

  if (request.status === 'error') throw new Error(request.message)

  const result = Array.isArray(request) ? request : []

  commit('SETEVENTPUBLICOALVO', result)
  return request
}

const loadAvisos = async ({ commit }, idPublicoAlvo) => {
  const request = await Fetch.get(
    'contentManagement/getAvisoProgramado',
    idPublicoAlvo
  )

  if (request.status === 'error') throw new Error(request.message)

  const result = Array.isArray(request) ? request : []

  commit('SETAVISOS', result)

  return request
}

export default {
  loadTipoAvisoList,
  setDateSelected,
  saveAvisoProgramado,
  loadListAvisos,
  setEventSelected,
  loadEventPublicoAlvo,
  loadAvisos
}
